export const TOAST_SERVICE_KEY = Symbol()
export const FILE_PRELOADER_SERVICE_KEY = Symbol()
export const LAYOUT_STORE_KEY = Symbol()
